import { createAction } from 'redux-actions';

export const GET_THEORY_REQUEST = createAction('GET_THEORY_REQUEST');
export const GET_THEORY_FAILURE = createAction('GET_THEORY_FAILURE');
export const GET_THEORY_SUCCESS = createAction('GET_THEORY_SUCCESS');

export const CHANGE_THEORY_MATCH_PARAMS = createAction('CHANGE_THEORY_MATCH_PARAMS');
